import { extendObject } from './object-extend';
/**
 * For the specified MediaChange, make sure it contains the breakpoint alias
 * and suffix (if available).
 */
export function mergeAlias(dest, source) {
    return extendObject(dest, source ? {
        mqAlias: source.alias,
        suffix: source.suffix
    } : {});
}
//# sourceMappingURL=add-alias.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/flex-layout/utils/add-alias.js
// module id = 185
// module chunks = 0